(ns ycweb.app.admin.wholesale.customers.common
  (:require
   [clojure.set :as set]
   [util.string :as str]
   [ycweb.util.core :as yuc]
   [ycweb.app.admin.wholesale.common :as w.cmn]))

(def view-permission
  "SiteAdmin:Wholesale:Customer:View")

(def view-permission-aged-receivables
  "SiteAdmin:Wholesale:Customer:View:AgedReceivables")

(def view-permission-set
  #{"SiteAdmin:Teams:Development" view-permission})

(def edit-permission
  "SiteAdmin:Wholesale:Customer:Edit")

(def edit-permission-set
  #{"SiteAdmin:Teams:Development" edit-permission})

(def edit-credit-on-hold-permission
  "SiteAdmin:Wholesale:Customer:Edit:CreditOnHold")

(def edit-sales-account-permission
  "SiteAdmin:Wholesale:Customer:Edit:SalesAccount")

(def api-permission-set
  (set
    (conj w.cmn/api-permissions
      view-permission)))

(defn validation-rules [action opts]
  (yuc/maybe assoc
    {:customer/name [:required :string]
     :customer/vat-number [:nillable :string]
     :customer/payment-term-id
     [:required
      {:rule :in
       :config {:list (:payment-term-ids opts [])}}]
     :customer/tax-rule-id
     [:required
      {:rule :in
       :config {:list (:tax-rule-ids opts [])}}]
     :customer/currency-id
     [:required
      {:rule :in
       :config {:list (:currency-ids opts [])}}]
     :customer/sale-account-id
     [:required
      {:rule :in
       :config {:list (:sale-account-ids opts [])}}]}
    :customer/uuid (when (= action :edit) [:required :uuid])
    :customer/active (when (= action :edit) [:required :boolean])
    :customer/is-on-credit-hold (when (= action :edit) [:nillable :boolean])
    :customer/delivery-company-id
    (when (= action :edit)
      [:nillable
       {:rule :in
        :config {:list (:delivery-company-ids opts [])}}])
    :customer/sales-rep-id
    (when (= action :edit)
      [:nillable
       {:rule :in
        :config {:list (:sale-rep-ids opts [])}}])))

(defn full-address [{:keys [address suburb city provincecode postalcode]}]
  (let [display-line-1
        (str/trim (when (yuc/presence address) address))
        [line1 line2] (str/split display-line-1 #",")
        display-line-2
        (str/trim
          (str
            (when (yuc/presence suburb) (str suburb ", "))
            (when (yuc/presence city) (str city ", "))
            (when (yuc/presence provincecode) (str provincecode ", "))
            (when (yuc/presence postalcode) postalcode)))]
    {:line-1 (str/trim line1)
     :line-2 (str/trim line2)
     :display-line-1 display-line-1
     :display-line-2 display-line-2}))

(defn transform-customer [customer {:keys [meta-data default-address default-contact]}]
  (let [{:keys [display-line-1 display-line-2]} (full-address default-address)]
    (->
      (yuc/maybe assoc customer
        :customer/total-orders (:total_orders meta-data)
        :contact/name (:name default-contact)
        :contact/tel (:tel default-contact)
        :contact/email (:email default-contact)
        :contact/website (:website default-contact)
        :address/full-display-lines (str display-line-1 " " display-line-2)
        :address/display-line-1 display-line-1
        :address/display-line-2 display-line-2)
      (set/rename-keys
        {:delivery_company_id :delivery-company-id
         :sale_account_id :sale-account-id
         :sales_rep_id :sales-rep-id
         :payment_term_id :payment-term-id
         :tax_rule_id :tax-rule-id
         :currency_id :currency-id
         :vat_number :vat-number
         :credit_limit :credit-limit})
      (yuc/map->nsmap "customer"))))